import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=2e0a949c&scoped=true&"
import script from "./persona.component.ts?vue&type=script&lang=ts&"
export * from "./persona.component.ts?vue&type=script&lang=ts&"
import style0 from "./persona.vue?vue&type=style&index=0&id=2e0a949c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a949c",
  null
  
)

export default component.exports